<div class="notifications-container column with-gap" #notificationsContainer>
  @for (notification of notifications; track notification) {
    <div class="notification column with-gap grow start-center">
      <div class="notification-toolbar row grow align-items-center justify-space-between">
        <div [ngClass]="[getNotificationStyle(notification.type)]">
          {{ notification.title | translate}}
        </div>
        <button id="closeButton" class="button icon transparent" (click)="closeNotification(notification)">
          x
        </button>
      </div>
      <div class="notification-message item align-self-start" [innerHTML]="notification.message">
      </div>
    </div>
  }
  @if (notifications.length > 1) {
    <button id="closeAllButton" class="close-all-button" (click)="closeAllNotifications()">
      {{ 'Shell.generic.closeAll' | translate }}
    </button>
  }
</div>
